import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

/**
 * Filters an admin sets on Home, the Estimates tab and the master data lists. Held for the
 * session so they survive switching tabs; cleared on reload.
 */
export interface AdminFilterValues {
  /** Home and Estimates tab. */
  growerId: string | null;
  farmId: string | null;
  /** Variety harvest weeks list. */
  hwVariety: string | null;
  hwWeek: number | null;
}

interface AdminFilterState extends AdminFilterValues {
  set: (patch: Partial<AdminFilterValues>) => void;
}

const EMPTY: AdminFilterValues = {
  growerId: null,
  farmId: null,
  hwVariety: null,
  hwWeek: null,
};

const Ctx = createContext<AdminFilterState>({ ...EMPTY, set: () => {} });

export function AdminFilterProvider({ children }: { children: ReactNode }) {
  const [values, setValues] = useState<AdminFilterValues>(EMPTY);
  const value = useMemo(
    () => ({
      ...values,
      set: (patch: Partial<AdminFilterValues>) => setValues((v) => ({ ...v, ...patch })),
    }),
    [values],
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAdminFilters(): AdminFilterState {
  return useContext(Ctx);
}
